export class Message {
  public SenderName : String;
  public SenderEmail : String;
  public SenderPhone : String;
  public SenderComment : String;

}
